import Dexie from 'dexie';

const db = new Dexie('strategia');

db.version(1).stores({
    attachments: 'id',
    statuses: 'id',
    session: 'id',
});

export default db;
